import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles(theme => ({
  titleContainer: {
    marginLeft: theme.spacing(2)
  }
}));
